import { render, staticRenderFns } from "./SingleNewsWestudy.vue?vue&type=template&id=131f814d&scoped=true&"
import script from "./SingleNewsWestudy.vue?vue&type=script&lang=js&"
export * from "./SingleNewsWestudy.vue?vue&type=script&lang=js&"
import style0 from "./SingleNewsWestudy.vue?vue&type=style&index=0&id=131f814d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f814d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VDivider,VImg,VRow,VSheet,VSkeletonLoader})
